import { render, staticRenderFns } from "./ReservationPeriodListItem.vue?vue&type=template&id=1f8544d2"
import script from "./ReservationPeriodListItem.vue?vue&type=script&lang=ts"
export * from "./ReservationPeriodListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports